module.exports = __webpack_public_path__ + "img/vandalism.1f93a16f.svg";